import {
  Button,
  HStack,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  ModalProps,
  VStack,
} from "@chakra-ui/react";
import { RiNotification2Fill } from "@remixicon/react";
import {
  dontAllowModalPermission,
  requestPermissionNotification,
} from "../../utils/helperFunction";
import { ModalTitle } from "../card/ModalTitle";

interface Props extends ModalProps {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export const ConfirmationPermissionModal = ({
  isOpen,
  onOpen,
  onClose,
}: Props) => {
  const dontShowAgain = () => {
    dontAllowModalPermission();
    onClose();
  };

  const activate = () => {
    requestPermissionNotification();
    onClose();
  };

  return (
    <Modal size={"xl"} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />

      <ModalContent>
        <ModalCloseButton />

        <ModalBody>
          <VStack w={"100%"} align={"stretch"}>
            <VStack w={"100%"}>
              <Icon
                as={RiNotification2Fill}
                color={"red.400"}
                fontSize={[100, null, 120]}
              />
            </VStack>

            <ModalTitle
              title="Jangan Ketinggalan Info Terbaru"
              subtitle="Tetap terhubung dengan mengaktifkan notifikasi dari BisnisLink. Dapatkan berita terkini, penawaran khusus, dan tips terbaik dari kami setiap minggunya!"
            />

            <HStack w={"100%"}>
              <Button
                w={"100%"}
                size={["sm", null, "md"]}
                colorScheme="red"
                variant={"ghost"}
                onClick={dontShowAgain}
              >
                Jangan Tampilkan Lagi
              </Button>

              <Button
                w={"100%"}
                size={["sm", null, "md"]}
                bgColor={"red.400"}
                colorScheme="red"
                onClick={activate}
              >
                Aktifkan Notifikasi
              </Button>
            </HStack>
          </VStack>
        </ModalBody>

        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
};
